module.exports = __webpack_public_path__ + "static/battleground-bfd4670a4e733e7816d57b888e448559.png";